import { Callback, Step } from 'react-joyride'

export type BeginTourParam = {
  callback?: Callback
  steps: Step[]
}

export enum TOUR_ACTIONS {
  SET_CALLBACK = 'TOUR_ACTIONS.SET_CALLBACK',
  SET_IS_TOUR_RUNNING = 'TOUR_ACTIONS.SET_IS_TOUR_RUNNING',
  SET_STEPS = 'TOUR_ACTIONS.SET_STEPS',
}

type SetCallback = {
  type: typeof TOUR_ACTIONS.SET_CALLBACK
  callback?: Callback
}

type SetIsTourRunning = {
  type: typeof TOUR_ACTIONS.SET_IS_TOUR_RUNNING
  isTourRunning: boolean
}

type SetSteps = {
  type: typeof TOUR_ACTIONS.SET_STEPS
  steps: Step[]
}

export type ActionTypes = SetCallback | SetIsTourRunning | SetSteps
